enum FormSubmissionState {
  NotSubmitted = 1,
  Submitting = 2,
  SubmissionSuccess = 3,
  SubmissionFailed = 4
}

export default FormSubmissionState;
